import { api, parseApiError } from './api';
import type { TaxReport, ReportsListResponse } from '@/types/report';

export const reportsService = {
  /**
   * Get list of tax reports for the authenticated user
   */
  async getReports(year?: number): Promise<ReportsListResponse> {
    try {
      const params: Record<string, string> = {};
      if (year) params.year = year.toString();

      const response = await api.get<ReportsListResponse>('/api/reports', { params });
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Get a single tax report by ID
   */
  async getReport(id: string): Promise<TaxReport> {
    try {
      const response = await api.get<TaxReport>(`/api/reports/${id}`);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default reportsService;
